module.exports = ol.layer.Tile;